export const formatDate = (date) => {
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const formatedDate = `${date.getFullYear()}-${month}-${day}`;
  return formatedDate;
};

export const formatDateTimeToISO = (date) => {
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const formatedDate = `${date.getFullYear()}-${month}-${day}`;
  return `${formatedDate}T${date.getHours().toString().padStart(2, "0")}:${date
    .getMinutes()
    .toString()
    .padStart(2, "0")}:${date.getSeconds().toString().padStart(2, "0")}Z`;
};

export const formatDateTime = (date) => {
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const formatedDate = `${date.getFullYear()}-${month}-${day}`;
  const formatedTime = date.toLocaleString("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${formatedDate}-T-${formatedTime}`;
};

export const formatTime = (date) => {
  if (typeof date === "string" || date === undefined || date === null) {
    return date;
  }
  var minute = date.getMinutes().toString().padStart(2, "0");
  var hour = date.getHours().toString().padStart(2, "0");
  const formatedDate = `${hour}:${minute}`;
  return formatedDate;
};

export const dateCheck = (from, to, check) => {
  var fDate, lDate, cDate;
  fDate = Date.parse(from?.replace(/-/g, "/"));
  lDate = Date.parse(to?.replace(/-/g, "/") ?? new Date());
  cDate = Date.parse(check?.replace(/-/g, "/"));

  if (cDate <= lDate && cDate >= fDate) {
    return true;
  }
  return false;
};
